module.exports = __webpack_public_path__ + "static/media/defaultImg.be7f149d.png";